import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
};

const searchText = createSlice({
  name: "searchText",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const {
  setSearch,
} = searchText.actions;

export default searchText.reducer;
